export function getCspNonce() {
  return document.head.querySelector('meta[name="csp-nonce"]')?.content;
}

export function getCsrfToken() {
  return document.head.querySelector('meta[name="csrf-token"]')?.content;
}

export function setCspNonceAttribute(element) {
  const nonce = getCspNonce();
  if (nonce) {
    element.setAttribute('nonce', nonce);
  }
}

// Patch for vendor libs and app code
export function patchDocumentHeadAppendChildWithCspStyleNonce() {
  const patchFlag = 'patched-with-scp-nonce';
  if (document.head[patchFlag]) return;
  document.head[patchFlag] = true;

  const originalAppendChild = document.head.appendChild;
  document.head.appendChild = function (node) {
    if (node instanceof HTMLStyleElement) {
      setCspNonceAttribute(node);
    }
    return originalAppendChild.call(this, node);
  };

  const originalInsertBefore = document.head.insertBefore;
  document.head.insertBefore = function (newNode, referenceNode) {
    if (newNode instanceof HTMLStyleElement) {
      setCspNonceAttribute(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}
